import { companyAudioRecordingApi, userAudioRecordingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_AUDIO_RECORDINGS_ACTION_TYPE = createNamedActions('companyAudioRecording', {
  UPDATE_AUDIO_RECORDING: 'UPDATE_AUDIO_RECORDING',
  GET_AUDIO_RECORDINGS: 'GET_AUDIO_RECORDINGS',
  CREATE_AUDIO_RECORDING: 'CREATE_AUDIO_RECORDING',
  GET_AUDIO_RECORDING_URL: 'GET_AUDIO_RECORDING_URL',
  EDIT_AUDIO_RECORDING_CONTENT: 'EDIT_AUDIO_RECORDING_CONTENT',
});

const audioRecordingsSchema = new schema.Entity('data', {}, { idAttribute: 'audioRecordingId' });

export const getCompanyAudioRecordingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyAudioRecordingApi.getAudioRecordings(params);

  return dispatch({
    type: COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDINGS,
    payload: normalize(data, [audioRecordingsSchema]).entities.data,
  });
});

export const getCompanyAudioRecordingUrlAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userAudioRecordingApi.getAudioRecordingUrl(params);

  return dispatch({
    type: COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDING_URL,
    payload: { url: data, audioRecordingId: params.audioRecordingId },
  });
});

export const createCompanyAudioRecordingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyAudioRecordingApi.createAudioRecording(params);

  return dispatch({
    type: COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.CREATE_AUDIO_RECORDING,
    payload: data,
  });
});

export const editCompanyAudioRecordingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyAudioRecordingApi.editAudioRecording(params);

  return dispatch({
    type: COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.UPDATE_AUDIO_RECORDING,
    payload: data,
  });
});

export const editCompanyAudioRecordingContentAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await userAudioRecordingApi.editAudioRecordingContent(params);

    return dispatch({
      type: COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.EDIT_AUDIO_RECORDING_CONTENT,
      payload: { ...data, url: undefined },
    });
  },
);
